import { render } from "./AnnouncementModal.vue?vue&type=template&id=75f61a26&scoped=true"
import script from "./AnnouncementModal.vue?vue&type=script&lang=js"
export * from "./AnnouncementModal.vue?vue&type=script&lang=js"

import "./AnnouncementModal.vue?vue&type=style&index=0&id=75f61a26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75f61a26"]])

export default __exports__